'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchMiniPdpProductBase } from '../api';
import { useMiniPdpDrawer } from './use-mini-pdp-drawer';
const ONE_HOUR = 60 * 60 * 1000;
export const MINI_PDP_PRODUCT_BASE_QUERY_KEY = 'mini-pdp-product-base';
export const useQueryMiniPdpBase = () => {
  const $ = _c(14);
  const isOpen = useMiniPdpDrawer(_temp);
  const productId = useMiniPdpDrawer(_temp2);
  let t0;
  let t1;
  if ($[0] !== productId) {
    t0 = [MINI_PDP_PRODUCT_BASE_QUERY_KEY, productId];
    t1 = async () => {
      if (!productId) {
        return null;
      }
      const response = await fetchMiniPdpProductBase(productId);
      if (!response) {
        throw new Error("Failed to fetch mini PDP product base");
      }
      return response;
    };
    $[0] = productId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = isOpen && Boolean(productId);
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: ONE_HOUR,
      retry: false
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data,
    isLoading,
    isPending,
    isFetching,
    isError,
    error
  } = useQuery(t3);
  let t4;
  if ($[7] !== data || $[8] !== error || $[9] !== isError || $[10] !== isFetching || $[11] !== isLoading || $[12] !== isPending) {
    t4 = {
      data,
      isLoading,
      isPending,
      isFetching,
      isError,
      error
    };
    $[7] = data;
    $[8] = error;
    $[9] = isError;
    $[10] = isFetching;
    $[11] = isLoading;
    $[12] = isPending;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(state) {
  return state.isOpen;
}
function _temp2(state_0) {
  return state_0.productId;
}